import { programTemplatesClient } from "../api/ApiClients";
import {
  IUseProgramTemplateCommand,
  ICreateProgramTemplateCommand,
  IUpdateProgramTemplateCommand,
  ProgramTemplateCategory,
  ProgramTemplateType,
  UseProgramTemplateCommand,
  CreateProgramTemplateCommand,
  UpdateProgramTemplateCommand,
  ICreateEmptyProgramTemplateCommand,
  CreateEmptyProgramTemplateCommand,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class ProgramTemplatesService extends ServiceBase {
  async getProgramTemplates(
    category?: ProgramTemplateCategory,
    type?: ProgramTemplateType,
  ) {
    return programTemplatesClient.getProgramTemplates(
      category,
      type,
    );
  }

  async getProgramTemplate(id: number) {
    return programTemplatesClient.getProgramTemplate(id);
  }

  async createProgramTemplate(variables: ICreateProgramTemplateCommand) {
    // workaround to set the name of the template (command constructor ignores it)
    const command = { ...CreateProgramTemplateCommand.fromJS(variables), name: variables.name } as CreateProgramTemplateCommand;
    return programTemplatesClient.createProgramTemplate(command);
  }

  async createEmptyProgramTemplate(variables: ICreateEmptyProgramTemplateCommand) {
    const command = CreateEmptyProgramTemplateCommand.fromJS(variables);
    return programTemplatesClient.createEmptyProgramTemplate(command);
  }

  async updateProgramTemplate(variables: IUpdateProgramTemplateCommand) {
    const command = UpdateProgramTemplateCommand.fromJS(variables);
    return programTemplatesClient.updateProgramTemplateById(variables.id, command);
  }

  async deleteProgramTemplate(id: number) {
    return programTemplatesClient.deleteProgramTemplate(id);
  }

  async useProgramTemplate(variables: IUseProgramTemplateCommand) {
    const command = UseProgramTemplateCommand.fromJS(variables);
    return programTemplatesClient.useProgramTemplate(command);
  }

  async shareProgramTemplateWithTeam(templateId: number) {
    return programTemplatesClient.shareProgramTemplateWithTeam(templateId);
  }

  async unshareProgramTemplateFromTeam(templateId: number) {
    return programTemplatesClient.unshareProgramTemplateFromTeam(templateId);
  }
}

export default new ProgramTemplatesService();
